import React, { Component } from 'react';
import Icon from '../icon';
import RcRate from '../rc-components/rate';
import ConfigContext from '../config-provider/ConfigContext';
export default class Rate extends Component {
    constructor() {
        super(...arguments);
        this.saveRate = (node) => {
            this.rcRate = node;
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    focus() {
        this.rcRate.focus();
    }
    blur() {
        this.rcRate.blur();
    }
    render() {
        const { getPrefixCls } = this.context;
        return React.createElement(RcRate, Object.assign({ ref: this.saveRate, prefixCls: getPrefixCls('rate') }, this.props));
    }
}
Rate.displayName = 'Rate';
Rate.defaultProps = {
    character: React.createElement(Icon, { type: "star" }),
};
